import { appMethod as app } from '@utils/app';

import { getCurrentPageQueryParams, convertLineStyleData } from '@utils/tools';
import { TopNav } from '@common/top-nav/TopNav';
import OfficialPage from '../OfficialPage';

import './TransferOrderDetail.less';

export default class TransferOrderDetail extends OfficialPage {
  state = {
    orderInfo: {},
    combinationBenefit: {},
    orderStatus: { '0': '待付款', '6': '已完成', '7': '已关闭' },
    isFromBack: false,
    isFromTemplateMsg: false,
    orderId: '',
    discountList: []
  }

  componentWillMount(options = getCurrentPageQueryParams()) {
    this.setData({
      orderId: options.detail,
      isFromTemplateMsg: options.from === 'template_msg' ? true : false,
      franchiseeId: options.franchisee || ''
    })
    this.dataInitial()
  }

  dataInitial = () => {
    this.getOrderDetail(this.data.orderId)
  }

  componentDidMount() {
    if (this.data.isFromBack) {
      if (!!this.data.orderId) {
        this.getOrderDetail(this.data.orderId, 1)
      }
    } else {
      this.setData({
        isFromBack: true
      })
    }
  }

  turnToFormDetail = () => {
    let pay_form_data = this.data.orderInfo.pay_form_data
    app.turnToPage(
      '/userCenter/pages/myMessage/myMessage?from=transforDetail&formid=' +
      pay_form_data.pay_form_id +
      '&form=' +
      pay_form_data.pay_form +
      '&formDataId=' +
      pay_form_data.pay_form_data_id
    )
  }
  getOrderDetail = (orderId, isFromAddrSelect) => {
    let that = this,
      combinationBenefit = {}
    app.getOrderDetail({
      data: {
        order_id: orderId,
        sub_shop_app_id: this.data.franchiseeId
      },
      success: function(res) {
        let orderInfo = res.data[0].form_data,
          address_id = ''
        if (orderInfo.selected_combination_benefit) {
          combinationBenefit = orderInfo.selected_combination_benefit // 保留两位小数处理
          combinationBenefit.store_benefit &&
          combinationBenefit.store_benefit.discount_price
            ? (combinationBenefit.store_benefit.discount_price = (+combinationBenefit
              .store_benefit.discount_price).toFixed(2))
            : ''
          combinationBenefit.vip_benefit_discount_price
            ? (combinationBenefit.vip_benefit_discount_price = (+combinationBenefit.vip_benefit_discount_price).toFixed(
            2
            ))
            : ''
          combinationBenefit.coupon_benefit_discount_price
            ? (combinationBenefit.coupon_benefit_discount_price = (+combinationBenefit.coupon_benefit_discount_price).toFixed(
            2
            ))
            : ''
          combinationBenefit.integral_benefit &&
          combinationBenefit.integral_benefit.discount_price
            ? (combinationBenefit.integral_benefit.discount_price = (+combinationBenefit
              .integral_benefit.discount_price).toFixed(2))
            : ''
        }
        orderInfo.store_benefit_info &&
        orderInfo.store_benefit_info.discount_price
          ? (orderInfo.store_benefit_info.discount_price = (+orderInfo
            .store_benefit_info.discount_price).toFixed(2))
          : ''
        orderInfo.selected_benefit_info &&
        orderInfo.selected_benefit_info.discount_cut_price
          ? (orderInfo.selected_benefit_info.discount_cut_price = (+orderInfo
            .selected_benefit_info.discount_cut_price).toFixed(2))
          : ''
        orderInfo.use_balance
          ? (orderInfo.use_balance = (+orderInfo.use_balance).toFixed(2))
          : ''
        orderInfo.coupon_fee
          ? (orderInfo.coupon_fee = (+orderInfo.coupon_fee).toFixed(2))
          : ''
        delete orderInfo.can_use_benefit.coupon_benefit
        that.setData({
          orderInfo: orderInfo,
          combinationBenefit: combinationBenefit,
          discountList: orderInfo.can_use_benefit.data,
          index: orderInfo.can_use_benefit.selected_index
        })
      }
    })
  }
  cancelOrder = e => {
    var orderId = this.data.orderId,
      that = this
    app.showModal({
      content: '是否取消订单？',
      showCancel: true,
      confirmText: '是',
      cancelText: '否',
      confirm: function() {
        app.sendRequest({
          url: '/index.php?r=AppShop/cancelOrder',
          data: {
            order_id: orderId,
            sub_shop_app_id: that.data.franchiseeId
          },
          success: function(res) {
            var data = {}
            data['orderInfo.status'] = '7'
            that.setData(data)
          }
        })
      }
    })
  }
  payOrder = e => {
    var that = this,
      orderId = this.data.orderId
    if (this.data.orderInfo.total_price == 0) {
      app.sendRequest({
        url: '/index.php?r=AppShop/paygoods',
        data: {
          order_id: orderId,
          total_price: 0
        },
        success: function(res) {
          that.getOrderDetail(that.data.orderId)
        }
      })
      return
    }
    // app.sendRequest({
    //   url: '/index.php?r=AppShop/GetWxWebappPaymentCode',
    //   data: {
    //     order_id: orderId
    //   },
    //   success: function(res) {
    //     var param = res.data,
    //       orderId = that.data.orderId
    //     param.orderId = orderId
    //     param.goodsType = that.data.orderInfo.goods_type
    //     param.success = function() {
    //       setTimeout(function() {
    //         that.getOrderDetail(orderId)
    //       }, 1500)
    //     }
    //     app.wxPay(param)
    //   }
    // })

    app.goPay({
      orderId: orderId
    });
  }
  goToHomepage = () => {
    var router = app.getHomepageRouter()
    app.turnToPage('/pages/' + router + '/' + router, true)
  }
  changeDiscount = e => {
    var _this = this
    var index = _this.data.orderInfo.can_use_benefit.selected_index
    var value = parseInt(e.target.value)
    this.setData({
      index: value
    })
    var discount_type =
        _this.data.orderInfo.can_use_benefit.data[value].discount_type,
      coupon_id = _this.data.orderInfo.can_use_benefit.data[value].coupon_id
    app.sendRequest({
      url: '/index.php?r=AppShop/ChangeOrder',
      data: {
        app_id: app.getAppId(),
        order_id: _this.data.orderId,
        discount_type: discount_type,
        coupon_id: coupon_id,
        sub_shop_app_id: _this.data.franchiseeId
      },
      success: function(res) {
        _this.getOrderDetail(_this.data.orderId)
      }
    })
  }
  verificationCode = () => {
    app.turnToPage(
      '/eCommerce/pages/verificationCodePage/verificationCodePage?detail=' +
      this.data.orderId +
      '&sub_shop_app_id=' +
      this.data.franchiseeId
    )
  }
  toFixed2 = num => {
    return (+num).toFixed(2)
  }

  render() {
    const { orderInfo, combinationBenefit } = this.state
    return (
      <div className="official-page transfer-order-detail">
        <TopNav title="当面付订单"/>
        <div className="transfer-wrap">
          <div className="top-block">
            {orderInfo.status === '6' && (
              <img
                className="icon-img"
                src="http://www.zhichiwangluo.com/zhichi_frontend/static/webapp/images/transfer/finish-icon.svg"
              />
                )}
                {(orderInfo.status === '0' || orderInfo.status === '7') && (
                  <img
                    className="icon-img"
                    src="http://www.zhichiwangluo.com/zhichi_frontend/static/webapp/images/transfer/no-finish-icon.svg"
                  />
                    )}
                    <div className="text">
                      {orderInfo.status === '0'
                        ? '订单未完成'
                        : orderInfo.status === '6'
                          ? '订单已完成'
                          : orderInfo.status === '7'
                            ? '订单已关闭'
                            : ''}
                    </div>
                    <img
                      className="bg-img"
                      src="http://www.zhichiwangluo.com/zhichi_frontend/static/webapp/images/transfer/wave.png"
                    />
                    </div>
          <div className="total-payment">
            <div className="content">
              <div className="text">实付金额</div>
              <div className="price">{'¥' + orderInfo.total_price}</div>
            </div>
          </div>
          <div className="transfer-detail">
            <div className="detail-item">
              <div className="detail-text">消费金额</div>
              <div className="detail-content">
                {'¥' + orderInfo.original_price}
              </div>
            </div>
            {/*  唯一优惠  */}
            {orderInfo.store_benefit_info &&
            orderInfo.store_benefit_info.discount_price &&
            orderInfo.store_benefit_info.discount_price != 0 && (
              <div className="detail-item">
                <div className="detail-text">店铺满减</div>
                <div className="detail-content">
                  {'-¥' + orderInfo.store_benefit_info.discount_price}
                </div>
              </div>
            )}
            {orderInfo.selected_benefit_info && (orderInfo.selected_benefit_info.discount_type === 'vip' ||
              orderInfo.selected_benefit_info.discount_type === 'paid_vip' ||
              orderInfo.selected_benefit_info.discount_type ===
              'vip_benefit_day') &&
            orderInfo.selected_benefit_info.discount_cut_price &&
            orderInfo.selected_benefit_info.discount_cut_price != 0 && (
              <div className="detail-item">
                <div className="detail-text">会员卡优惠</div>
                <div className="detail-content">
                  {'-¥' + orderInfo.selected_benefit_info.discount_cut_price}
                </div>
              </div>
            )}
            {orderInfo.selected_benefit_info && orderInfo.selected_benefit_info.discount_type === 'coupon' &&
            orderInfo.selected_benefit_info.discount_cut_price &&
            orderInfo.selected_benefit_info.discount_cut_price != 0 && (
              <div className="detail-item">
                <div className="detail-text">券类优惠</div>
                <div className="detail-content">
                  {'-¥' + orderInfo.selected_benefit_info.discount_cut_price}
                </div>
              </div>
            )}
            {orderInfo.selected_benefit_info && orderInfo.selected_benefit_info.discount_type === 'integral' &&
            orderInfo.selected_benefit_info.discount_cut_price &&
            orderInfo.selected_benefit_info.discount_cut_price != 0 && (
              <div className="detail-item">
                <div className="detail-text">积分抵扣</div>
                <div className="detail-content">
                  {'-¥' + orderInfo.selected_benefit_info.discount_cut_price}
                </div>
              </div>
            )}
            {/*  自定义优惠  */}
            {combinationBenefit.store_benefit &&
            combinationBenefit.store_benefit.discount_price &&
            combinationBenefit.store_benefit.discount_price != 0 && (
              <div className="detail-item">
                <div className="detail-text">店铺满减</div>
                <div className="detail-content">
                  {'-¥' + combinationBenefit.store_benefit.discount_price}
                </div>
              </div>
            )}
            {combinationBenefit.vip_benefit_discount_price &&
            combinationBenefit.vip_benefit_discount_price != 0 && (
              <div className="detail-item">
                <div className="detail-text">会员卡优惠</div>
                <div className="detail-content">
                  {'-¥' + combinationBenefit.vip_benefit_discount_price}
                </div>
              </div>
            )}
            {combinationBenefit.coupon_benefit_discount_price &&
            combinationBenefit.coupon_benefit_discount_price != 0 && (
              <div className="detail-item">
                <div className="detail-text">券类优惠</div>
                <div className="detail-content">
                  {'-¥' + combinationBenefit.coupon_benefit_discount_price}
                </div>
              </div>
            )}
            {combinationBenefit.integral_benefit &&
            combinationBenefit.integral_benefit.discount_price &&
            combinationBenefit.integral_benefit.discount_price != 0 && (
              <div className="detail-item">
                <div className="detail-text">积分抵扣</div>
                <div className="detail-content">
                  {'-¥' + combinationBenefit.integral_benefit.discount_price}
                </div>
              </div>
            )}
            {orderInfo.use_balance && orderInfo.use_balance != 0 && (
              <div className="detail-item">
                <div className="detail-text">储值</div>
                <div className="detail-content">
                  {'-¥' + orderInfo.use_balance}
                </div>
              </div>
            )}
            {orderInfo.coupon_fee && orderInfo.coupon_fee != 0 && (
              <div className="detail-item">
                <div className="detail-text">社交立减金</div>
                <div className="detail-content">
                  {'-¥' + orderInfo.coupon_fee}
                </div>
              </div>
            )}
          </div>
          {orderInfo.remark && (
            <div className="remarks">
              <div className="text">备注</div>
              <div className="content">{orderInfo.remark}</div>
            </div>
          )}
          {orderInfo.status === '0' && (
            <div className="transfer-bottom-operation">
              <span className="btn carry-btn" onClick={this.payOrder}>
                支付
              </span>
              <span className="btn cancel-btn" onClick={this.cancelOrder}>
                取消支付
              </span>
            </div>
          )}
        </div>
    </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/official-page/transfer-order-detail/TransferOrderDetail.jsx